import http from './http';

export default {
    async login(credentials) {
        console.log(credentials);

        try {
            const response = await http.post('/user/login/login', credentials);
            if (response.code === 1) {
                const { data } = response;
                // 存储 token 和用户信息
                localStorage.setItem('authToken', data.token);
                localStorage.setItem('userInfo', JSON.stringify(data.user));
            }
            return response;
        } catch (error) {
            console.error('登录失败:', error);
            throw error;
        }
    },
    logout() {
        // 清除 token 和用户信息
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        // 重定向到登录页面
        window.location.href = '/login';
    }
};
